//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { EncryptionService } from '../../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { forkJoin, Observable, of, Subject, switchMap } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../../../general/http-client-service';
import { ExceptionsService } from '../../../general/exceptions-service';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';
import { Ticket } from 'src/app/core/models/system/support/ticket-hub/ticket';
import { TicketDTO } from 'src/app/core/models/system/support/ticket-hub/ticket.dto';
import { TicketCommentDTO } from 'src/app/core/models/system/support/ticket-hub/ticket-comment.dto';
import { TicketComment } from 'src/app/core/models/system/support/ticket-hub/ticket-comment';

@Injectable({ providedIn: 'root' })

export class TicketHubService {

   private ticketCreateSource = new Subject<void>();

  ticketCreated$ = this.ticketCreateSource.asObservable();

  emitTicketCreate() {
    this.ticketCreateSource.next();
  }
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }
    
  public getById(id: number): Observable<TicketDTO> {
    try {
      return this.httpClientService.getById(environment.eSimApi + eSimApiPaths.Tickets + "/", id);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getUserAndCompanyTickets(companyId          : number,
                                  userId             : number,
                                  deviceId           : number,
                                  openTickets        : boolean,
                                  matchCompanyAndUser: boolean): Observable<Ticket[]> {
    try {
      return forkJoin({
               companyIdEncResult          : this.encryptionService.encrypt_AesServerSideForWeb((companyId           ?? -1   ).toString(), true),
               userIdEncResult             : this.encryptionService.encrypt_AesServerSideForWeb((userId              ?? -1   ).toString()),
               deviceIdEncResult           : this.encryptionService.encrypt_AesServerSideForWeb((deviceId            ?? -1   ).toString()),
               openTicketsEncResult        : this.encryptionService.encrypt_AesServerSideForWeb((openTickets         ?? true ).toString()),
               matchCompanyAndUserEncResult: this.encryptionService.encrypt_AesServerSideForWeb((matchCompanyAndUser ?? false).toString())
             })
             .pipe(
               switchMap(({ companyIdEncResult, userIdEncResult, deviceIdEncResult, openTicketsEncResult, matchCompanyAndUserEncResult }) => {
                 const companyIdEncSS        =companyIdEncResult.result;
                 const userIdEnc             =userIdEncResult.result;
                 const deviceIdEnc           =deviceIdEncResult.result;
                 const openTicketsEnc        =openTicketsEncResult.result;
                 const matchCompanyAndUserEnc=matchCompanyAndUserEncResult.result;

                 return this.httpClientService.get<Ticket[]>(environment.eSimApi +
                                                             eSimApiPaths.Tickets + "/" +
                                                             eSimApiPaths.GetUserAndCompanyTickets +
                                                             "?companyIdEncSS="         + companyIdEncSS +
                                                             "&userIdEnc="              + userIdEnc +
                                                             "&deviceIdEnc="            + deviceIdEnc +
                                                             "&openTicketsEnc="         + openTicketsEnc +
                                                             "&matchCompanyAndUserEnc=" + matchCompanyAndUserEnc);
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public post(ticket: TicketDTO): Observable<TicketDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(ticket))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const ticketEnc=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.Tickets + "/" +
                                                               eSimApiPaths.TicketPost,
                                                               { data: ticketEnc },
                                                               undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public addComent(ticketComment: TicketCommentDTO): Observable<void> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(ticketComment))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const ticketCommentEnc=encResult.result;

                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.Tickets + "/" +
                                                               eSimApiPaths.AddTicketComment +
                                                               "?ticketCommentEnc=" + ticketCommentEnc, {});
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public addReply(ticketComment: TicketCommentDTO): Observable<void> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(ticketComment))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const ticketCommentEnc=encResult.result;

                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.Tickets + "/" +
                                                               eSimApiPaths.AddTicketReply +
                                                               "?ticketCommentEnc=" + ticketCommentEnc, {});
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getTicketComment(id: number, companyId : number): Observable<TicketComment[]> { 
    try {
      return forkJoin({
               idEncResult       : this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(id), true),
               companyIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(companyId))
             })
             .pipe(
               switchMap(({ idEncResult, companyIdEncResult }) => {
                 const idEncSS     =idEncResult.result;
                 const companyIdEnc=companyIdEncResult.result;
                 
                 return this.httpClientService.get<TicketComment[]>(environment.eSimApi +
                                                                    eSimApiPaths.Tickets + "/" +
                                                                    eSimApiPaths.GetTicketComments +
                                                                    "?idEncSS=" + idEncSS +
                                                                    "&freshdeskCompanyIdEnc=" + companyIdEnc,
                                                                    {}
                                                                   );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public put(ticket: Ticket): Observable<boolean> {
    try {
      return forkJoin({
               idEncResult    : this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(ticket.id)),
               objectEncResult: this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(ticket))
             })
             .pipe(
               switchMap(({ idEncResult, objectEncResult }) => {
                 const idEnc    =idEncResult.result;
                 const objectEnc=objectEncResult.result;
                 
                 return this.httpClientService.put(environment.eSimApi +
                                                   eSimApiPaths.Tickets + "/" +
                                                   eSimApiPaths.TicketPut,
                                                   undefined,
                                                   { data: objectEnc, ticketIdEnc: idEnc },
                                                   undefined
                                                  );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
